import { useExperienceApi } from '@/shared/api/useExperienceApi.ts';

// TODO переделать на сервис пермиссий
export function useUserInfo() {
  const { getUser } = useExperienceApi();

  async function fetchUser() {
    return getUser();
  }

  return {
    fetchUser,
  };
}
